/** Hydra `redirectTo` を `window.location.href` 代入前にチェックする多層防御。許可は `http:` / `https:` のみ。 */
const SAFE_PROTOCOLS = new Set(['http:', 'https:']);
export const isSafeRedirectTo = (value: string | null | undefined): value is string => {
  if (!value || typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (trimmed.length === 0) return false;

  // URL コンストラクタが通してしまう dangerous scheme を明示的に弾く
  const normalized = trimmed.toLowerCase();
  if (normalized.startsWith('javascript:') || normalized.startsWith('data:') || normalized.startsWith('vbscript:') || normalized.startsWith('file:')) {
    return false;
  }
  try {
    const url = new URL(trimmed);
    return SAFE_PROTOCOLS.has(url.protocol);
  } catch {
    return false;
  }
};